import React from 'react';

import { InputAdornment, FormControl, OutlinedInput, InputLabel } from '@mui/material';
import KeywordToolTip from 'src/components/keyword-tooltip';

export const PhoneNumberField = ({
  value,
  label,
  placeholder = '(123) 456-7890',
  handleFocus,
  onChange,
  size,
  disabled,
  sx,
  name,
}) => {
  const formatPhoneNumber = (input) => {
    // Remove all non-numeric characters and limit to 10 digits
    const cleaned = (input ?? '').replace(/\D/g, '').replace('+1', '').slice(0, 10);

    // Split the input into the three parts
    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);

    if (match) {
      // Format the output
      const formatted = !match[2]
        ? match[1]
        : `(${match[1]}) ${match[2]}${match[3] ? `-${match[3]}` : ''}`;
      return formatted;
    }

    return String(input);
  };

  const handleChange = (e) => {
    const formattedValue = formatPhoneNumber(e.target.value ?? '');
    const numericValue = `${formattedValue?.replace(/\D/g, '')}`; // Remove non-numeric characters
    onChange({ ...e, target: { ...e.target, value: numericValue, name: name ?? 'phoneNumber' } }); // Pass numeric value up to parent
  };

  return (
    <FormControl fullWidth {...{ size, ...sx }}>
      <InputLabel id="phone-label">
        <KeywordToolTip keyword={label} />
      </InputLabel>

      <OutlinedInput
        onFocus={handleFocus}
        label={<KeywordToolTip keyword={label} />}
        placeholder={placeholder}
        value={formatPhoneNumber(value) ?? ''}
        onChange={handleChange}
        startAdornment={<InputAdornment position="start">+1</InputAdornment>}
        disabled={disabled}
      />
    </FormControl>
  );
};
